import classNames from "classnames";
import Variant from "shared/enums/Variant";

export function getClassNames(args: {
  variant?: Variant;
  className?: string;
  disabled?: boolean;
  iconOnly?: boolean;
  isOutline?: boolean;
  hasShadow?: boolean;
  isButtonWithIconText?: boolean;
}) {
  const getButtonClass = () => {
    if (args.iconOnly && args.isOutline) {
      return `ptButton--${args.variant}IconOnlyOutlined`;
    } else if (args.iconOnly) {
      return `ptButton--${args.variant}IconOnly`;
    } else if (args.isOutline) {
      return `ptButton--${args.variant}Outlined`;
    } else {
      return `ptButton--${args.variant}`;
    }
  };
  return classNames("ptButton", args.className, getButtonClass(), {
    "ptButton--disabled": args.disabled,
    "ptButton--hasShadow": args.hasShadow,
    "ptButton--isButtonWithIconText": args.isButtonWithIconText
  });
}

export function getDefaultTitle(args: { label?: string | null; title?: string; default: string }) {
  if (args.title) return args.title;
  if (args.label) return args.label;
  return args.default;
}
